import React, { useState, useEffect } from "react";
import "./index.scss";
import Translation from "components/common/translations";
import AuthController from "controllers/authController";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resolveLoginPromise } from "utils";
import close2 from "assets/images/close2.png";

export default function ShowConfirmCode({
  email,
  onClose,
  isExpired,
  setVisible,
}) {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [countdown, setCountdown] = useState(30);
  const [isTimerActive, setIsTimerActive] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (isTimerActive && countdown > 0) {
      const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      setIsTimerActive(false);
    }
  }, [countdown, isTimerActive]);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1);
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleConfirm = async () => {
    const code = otp.join("");
    const response = await AuthController.confirm(email, code);

    if (response && response.access_token && response.refresh_token) {
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("refresh_token", response.refresh_token);
      if (isExpired) {
        setVisible(false);
        resolveLoginPromise();
      } else {
        navigate("/personalAccount");
      }
      AuthController.setLoginStatus(true);
      onClose();
    } else {
      toast.error("Verification code is incorrect");
    }
  };

  const handleResendCode = async () => {
    await AuthController.resendCode(email);
    setCountdown(30);
    setIsTimerActive(true);
  };

  const handleCancel = () => {
    onClose();
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  return (
    <div className="div-confirmCode-all">
      <div className="div-confirmCode-second">
        <div>
          <div className="img-close2">
            <img src={close2} alt="close" onClick={handleCancel} />
          </div>

          <h2 className="h2-confirm-code">
            <Translation label={"_confirmEmail"} />
          </h2>

          <div className="otp-input-container">
            {otp.map((value, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength="1"
                value={value}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyPress(e, index)}
                className="otp-input"
              />
            ))}
          </div>

          <div>
            <button onClick={handleConfirm} className="button-confirm">
              <Translation label={"_confirmButton"} />
            </button>
          </div>

          <div>
            <button
              onClick={handleResendCode}
              className="button-cancel"
              disabled={isTimerActive}
            >
              {isTimerActive ? (
                <span>
                  <Translation label={"_resendCode"} /> ({countdown})
                </span>
              ) : (
                <Translation label={"_resendCode"} />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
